module.exports = __webpack_public_path__ + "img/logo_secogey - copia.74939d98.jpg";